import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet, isInToolbar, openedFacetId, setOpenedFacetId }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    useEffect(()=>{
        if(active && openedFacetId !== facet?.id){
            setActive(false);
        }
    }, [openedFacetId])

    // new logic for clicking outside of the facet 
    const facetRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (facetRef.current && !facetRef.current.contains(event.target)) {
            if (active) {
                setActive(false);
              if (isInToolbar) {
                setOpenedFacetId(null);
              }
            }
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [active, setActive, isInToolbar, setOpenedFacetId]);

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} ref={facetRef}>
            <span
                class={`ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box ${!isInToolbar ? "ns-p-4" : ""}`}
                onClick={() => {
                    setActive(!active);
                    setOpenedFacetId(facet.id);
                }}
            >
                <span class="ns-color-black ns-font-4 ns-font-bold">{facet.name}</span>
                {/* {isSelected && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {1}
                    </span>
                )} */}
                <img src="https://d21m4dsqdd3b9h.cloudfront.net/bigcommerce-f4083/onsiteContent/17454922466190.8147754591327114" alt="Dropdown Icon" class="ns-dropdown-icon" aria-hidden="false"></img>
            </span>
            <div class="ns-sidebar-submenu ns-d-none">
                <div class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-5 ns-p-4">
                {/* ns-col-6 flex-shrink-1 */}
                    <div class="ns-range-input-container">
                        {/* <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label> */}
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-ml-2 ns-mr-2 ns-font-bold">-</div>
                    {/* ns-col-6 flex-shrink-1 */}
                    <div class="ns-range-input-container">
                        {/* <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label> */}
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div>
                {/* <RangeSlider id={facet.id} /> */}
                {isInToolbar && <div class="ns-apply-btn-container ns-p-4">
                    <button class="ns-apply-btn" onClick={() => {
                        setActive(!active)
                    }}>View Results</button>
                </div>}
            </div>
        </li>
    )
}
